import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import Dashboard from './Designer/Dashboard';


class PlatformDashboard extends React.Component {

  async componentWillMount() {
    dispatch.platform.setAcceptServerEvents(true);
    dispatch.platform.getStripeStats();
    dispatch.app.setCurrentContext("platform-dashboard");
  }

  componentWillUnmount() {
    
    dispatch.platform.setAcceptServerEvents(false);
  }

  render() {

    return (
      <div>
        <Route exact path="/app/platform/dashboard" render={() => (<Dashboard  {...this.props} />)} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.app.user,
    activeSessions: state.platform.activeSessions,
    accountsCount: state.platform.accountsCount,
    orgCount: state.platform.orgCount,
    userCount: state.platform.userCount,
    playbookCount: state.platform.playbookCount,
    contentCount: state.platform.contentCount,
    accounts: state.platform.accounts,
    loadingAccountsData: state.loading.effects.platform.getStats && state.loading.models.platform,
    stripeStats: state.platform.stripeStats,
    unRegisteredUsersData: state.platform.unRegisteredUsersData,
    allAccounts: state.platform.allAccounts,
    accountDetail: state.app.accountDetail,
    loaderForAllAccount: state.loading.effects.platform.getAllAccounts && state.loading.models.platform,
    planCounts: state.platform.planCounts,
    integrationsList:state.integrations.integrationsList,
    consumptionDetails: state.account.consumptionDetails,
    loadingConsumptions: state.loading.effects.account.getConsumptionDetails,
    activitiesGenerated: state.account.activitiesGenerated,
    playbooksCreated: state.account.playbooksCreated,
    linksGenerated: state.account.linksGenerated,
  };
}

const connectedDashboard = connect(mapStateToProps)(PlatformDashboard);

export { connectedDashboard as PlatformDashboard };